<form>

	<div class="form-group switch-custom-container pb-0 mb-0">
		<h2 data-testid="SUBSYS5_MOTMESSAGES_TITLE_TXT" class="text-uppercase">
			{{ labels().MOT_MESSAGES_COMPONENT_TITLE }}
		</h2>
		<label for="checkbox" class="switch ms-5">
			<input data-testid="SUBSYS5_MOTMESSAGES_TOGGLE" type="checkbox" [checked]="isEnabled()" (change)="toggle()">
			<span></span>
		</label>
	</div>
	<p data-testid="SUBSYS5_MOTMESSAGES_DESC_TXT" class="fst-italic mb-0">
		{{ labels().MOT_MESSAGES_COMPONENT_DESCRIPTION }}
	</p>

	@if (isEnabled()) {

	<div class="row justify-space-between mb-5">
		<div class="col d-flex align-items-end">
			@if (isEnabled() && !enableSet()?.length) {
			<div class="invalid-feedback d-block">{{ labels().MOT_MESSAGES_COMPONENT_LIST_REQUIRED }}</div>
			}
		</div>
		<div class="col-xxl-4 col-lg-5 col-6">
			<div class="form-group d-flex align-items-center pb-0">
				<label data-testid="SUBSYS5_MOTMESSAGES_SETS_LBL" for="messages-sets" class="mb-0"
					style="min-width: fit-content;">
					{{ labels().MOT_MESSAGES_COMPONENT_SET_SELECT_LABEL }}
				</label>
				<select data-testid="SUBSYS5_MOTMESSAGES_SETS_SELECT" id="messages-sets" class="form-control custom-select ms-5"
					[(ngModel)]="selectedSet" [ngModelOptions]="{ standalone: true}" (ngModelChange)="openCustomSetModal()">
					<option [ngValue]="null">--</option>
					@for (set of customSet(); track set.name) {
					<option [ngValue]="set.name">{{ set.name }}</option>
					}
				</select>
			</div>
		</div>
	</div>

	<ng-container [ngTemplateOutlet]="motMessagesBox" [ngTemplateOutletContext]="{ 
		items: strutAdjusts, 
		title: labels().MOT_MESSAGES_COMPONENT_STRUT_ADJUSTMENT, 
		isVisible: isStrutAdjustVisible 
		}">
	</ng-container>

	<ng-container [ngTemplateOutlet]="motMessagesBox" [ngTemplateOutletContext]="{ 
		items: pinSiteCares, 
		title: labels().MOT_MESSAGES_COMPONENT_PIN_SITE_CARE, 
		isVisible: isPinSiteCareVisible 
		}">
	</ng-container>

	<ng-container [ngTemplateOutlet]="motMessagesBox" [ngTemplateOutletContext]="{ 
		items: generalMsgs, 
		title: labels().MOT_MESSAGES_COMPONENT_MOTIVATIONAL_MESSAGES, 
		isVisible: isMotMsgVisible 
		}">
	</ng-container>

	<ng-container [ngTemplateOutlet]="motMessagesBox" [ngTemplateOutletContext]="{ 
		items: physTherapies, 
		title: labels().MOT_MESSAGES_COMPONENT_PHYSICAL_THERAPY, 
		isVisible: isPhysTherapyVisible 
		}">
	</ng-container>

	<div class="row mt-5">
		<div class="col d-flex justify-content-end">
			<button type="button" class="btn btn-primary" [disabled]="!selectedSet()" (click)="save()">
				{{ labels().MOT_MESSAGES_COMPONENT_SAVE_BTN }}
			</button>
			<button type="button" class="btn btn-primary ms-3" (click)="openModal(motMessageModal)">
				{{ labels().MOT_MESSAGES_COMPONENT_NEW_BTN }}
			</button>
			<button type="button" class="btn btn-primary ms-3" [disabled]="!selectedSet()"
				(click)="openModal(motMessageModal, true)">
				{{ labels().MOT_MESSAGES_COMPONENT_RENAME_BTN }}
			</button>
			<button type="button" class="btn btn-primary ms-3" [disabled]="!selectedSet()" (click)="openDeleteModal()">
				{{ labels().MOT_MESSAGES_COMPONENT_DELETE_BTN }}
			</button>
		</div>
	</div>

	}

</form>

<ng-template #motMessagesBox let-isVisible="isVisible" let-title="title" let-items="items">
	<div class="row">
		<div class="col">
			<h5 data-testid="SUBSYS5_MOTMESSAGES_ACCORDION_TOGGLE" class="title-accordion bg-cyan m-0"
				[ngClass]="{'active': isVisible }" (click)="collapse.toggle()" (keypress)="collapse.toggle()">
				{{ title }}
				<div class="fake-material-icon icon-expand expand"></div>
			</h5>
		</div>
	</div>

	<div class="row content-accordion" #collapse="ngbCollapse" [ngbCollapse]="!isVisible">
		<div class="col">
			<div class="form-group d-flex flex-wrap">
				<div class="w-100 p-4">
					<div class="custom-control custom-checkbox custom-control-inline">
						<input data-testid="SUBSYS5_MOTMESSAGES_ALL_INPUT" type="checkbox" name="struts"
							class="custom-control-input" id="struts_all" [checked]="isAllChecked(items())"
							(change)="checkAll(items(), $event)">
						<label data-testid="SUBSYS5_MOTMESSAGES_ALL_LBL" class="custom-control-label fw-bold fst-italic"
							for="struts_all">
							{{ labels().MOT_MESSAGES_COMPONENT_SELECT_ALL }}
						</label>
					</div>
				</div>
				@for (item of items(); track item.id) {
				<div class="w-50 px-5">
					<div class="custom-control custom-checkbox custom-control-inline w-100">
						<input data-testid="SUBSYS5_MOTMESSAGES_MSG_INPUT" type="checkbox" name="struts" #checkbox
							class="custom-control-input" [id]="'struts_'+item.id" [checked]="item.checked"
							(change)="item.checked = checkbox.checked" (change)="updateEnableSet()">
						<label data-testid="SUBSYS5_MOTMESSAGES_MSG_LBL" class="custom-control-label" [for]="'struts_'+item.id">
							{{ item.body }}
						</label>
					</div>
				</div>
				}
			</div>

		</div>
	</div>
</ng-template>

<ng-template #motMessageModal let-modal>
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title" data-testid="SUBSYS5_MOTMESSAGES_MODAL_TITLE_TXT">
				{{ isRename ? labels().MOT_MESSAGES_COMPONENT_RENAME_BTN : labels().MOT_MESSAGES_COMPONENT_NEW_BTN }}
			</h5>
			<button type="button" class="hide-focus"></button>
		</div>
		<div class="modal-body">
			<form>
				<div class="form-group">
					<input data-testid="SUBSYS5_MOTMESSAGES_MODAL_INPUT" type="text" class="form-control"
						[maxlength]="SETNAME_MAXLENGTH" [placeholder]="labels().MOT_MESSAGES_COMPONENT_MODAL_PLACEHOLDER"
						[(ngModel)]="setName" [ngModelOptions]="{ standalone: true}">
				</div>
			</form>
		</div>
		<div class="modal-footer">
			<button data-testid="SUBSYS5_MOTMESSAGES_MODAL_CANCEL_BTN" type="button" class="btn btn-secondary-outline"
				(click)="modal.dismiss()">
				{{ labels().CONFIRMATION_COMPONENT_CANCEL_BUTTON }}
			</button>
			<button data-testid="SUBSYS5_CONFIRMATION_MODAL_CONFIRM_BTN" type="button" class="btn btn-primary"
				[disabled]="!setName()" (click)="modal.close()">
				{{ labels().CONFIRMATION_COMPONENT_CONFIRM_BUTTON }}
			</button>
		</div>
	</div>
</ng-template>